module.exports = __webpack_public_path__ + "img/组 7475.5e578cda.5e578cda.png";